import React, { useState } from "react";
import { Box, Button, Checkbox, Input, Text, VStack } from "@chakra-ui/react";

export function CheckboxesActionWidget({ prompt, options = [], defaults, onSend }) {
  const [selected, setSelected] = useState(() => new Set(defaults ?? []));
  const [note, setNote] = useState("");
  const [submitted, setSubmitted] = useState(null);

  const toggle = (opt) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(opt)) next.delete(opt);
      else next.add(opt);
      return next;
    });
  };

  const canSubmit = selected.size > 0 || note.trim().length > 0;

  const handleSubmit = () => {
    if (!canSubmit) return;
    const items = options.filter((o) => selected.has(o));
    let msg = items.length > 0 ? `Selected: ${items.join(", ")}` : "";
    if (note.trim()) msg = msg ? `${msg}. Note: ${note.trim()}` : note.trim();
    setSubmitted(msg);
    onSend(msg);
  };

  if (submitted) {
    return (
      <Box bg="gray.50" borderWidth="1px" borderRadius="md" p={3} my={2}>
        <Text fontSize="xs" color="gray.500" mb={1}>
          {prompt}
        </Text>
        <Text fontSize="sm">✓ {submitted}</Text>
      </Box>
    );
  }

  return (
    <Box bg="white" borderWidth="1px" borderRadius="md" p={3} my={2}>
      <Text fontSize="sm" fontWeight="medium" mb={2}>
        {prompt}
      </Text>
      <VStack align="stretch" spacing={1}>
        {options.map((opt) => (
          <Checkbox
            key={opt}
            size="sm"
            isChecked={selected.has(opt)}
            onChange={() => toggle(opt)}
          >
            <Text fontSize="sm">{opt}</Text>
          </Checkbox>
        ))}
      </VStack>
      <Input
        mt={2}
        size="sm"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Something else? Type here..."
      />
      <Button mt={2} size="sm" variant="primary" onClick={handleSubmit} isDisabled={!canSubmit}>
        Submit
      </Button>
    </Box>
  );
}
